import React, { useEffect } from "react";
import { Form, Input, Button, Tooltip } from "antd";
import Index from "../Index";
import "./Registration.css";
import { Link, useNavigate } from "react-router-dom";
import { RegistrationActionHandler } from "../../Redux/Actions/common/Registration";
import { useDispatch, useSelector } from "react-redux";
import { MdInfoOutline } from "react-icons/md";
// import { notification } from "antd";

const Registration = () => {
  const mainLogo = "/assets/QA_Logo.svg";
  let dispatch = useDispatch();
  let Navigate = useNavigate();
  // const [api, contextHolder] = notification.useNotification();
  const registerdata = useSelector(
    (state) => state?.RegisterData?.register_data
  );

  const onFinish = (values) => {
    dispatch(RegistrationActionHandler(values));

    //gtm
    window.dataLayer.push({
      event: "Sign up ",
      buttonName: "Sign up",
      userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
      clientId: JSON.parse(localStorage.getItem("userDetails"))?.client_id,
    });
  };

  // const openNotificationWithIcon = (type) => {
  //   api[type]({
  //     message: registerdata?.message,
  //   });
  // };

  useEffect(() => {
    if (registerdata) {
      // openNotificationWithIcon("success");
      Navigate("/verification");
    }
    // eslint-disable-next-line
  }, [registerdata]);

  const tooltipContent = (
    <div className="remove-tooltip-space">
      <p>1. Your password must be 8 to 50 characters long.</p>
      <p>2. It must include at least one uppercase letter.</p>
      <p>3. It must include at least one lowercase letter.</p>
      <p>4. It must include at least one number.</p>
      <p>5. It must include at least one special character.</p>
      <p>6. It must not be the same as your user login ID.</p>
    </div>
  );

  return (
    <>
      <div className="signup-container">
        {/* {contextHolder} */}
        <Index />
        <div className="signup-main custom-scrollbar">
          <div className="signup-div ">
            <div className="center-img res-img">
              <img src={mainLogo} alt="" className="centered-image" />
            </div>

            <div className="signup_text">
              Start your 7 day free trial today.
            </div>
            <div className="signup_mid_text">
              <p>Unlock the power of generative Ai in business.</p>
            </div>

            <Form
              name="signupForm"
              initialValues={{
                company_name: "",
                first_name: "",
                last_name: "",
                email: "",
                password: "",
                password_confirmation: "",
              }}
              onFinish={onFinish}
              className="registration-class-form"
            >
              <div className="registration-label-name-div">
                <div>
                  <label>First Name</label>
                  <Form.Item
                    name="first_name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your firstname!",
                      },
                      {
                        pattern: /^[a-zA-Z]+$/,
                        message: "First name should only contain letters",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your firstname" />
                  </Form.Item>
                </div>

                <div>
                  <label>Last Name</label>
                  <Form.Item
                    name="last_name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your lastname!",
                      },
                      {
                        pattern: /^[a-zA-Z]+$/,
                        message: "First name should only contain letters",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your lastname" />
                  </Form.Item>
                </div>
              </div>

              <label>Your email</label>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input placeholder="Enter your email" />
              </Form.Item>

              <label>Company name </label>
              <Form.Item
                name="company_name"
                rules={[
                  {
                    required: true,
                    message: "Please input your company name!",
                  },
                  {
                    pattern: /^[^\d]+$/,
                    message: "Company name should not contain numbers",
                  },
                ]}
              >
                <Input placeholder="Enter your company name" />
              </Form.Item>

              <div className="passoord-tooltip">
                Password
                <Tooltip
                  placement="top"
                  title={tooltipContent}
                  overlayStyle={{ maxWidth: "900px" }}
                >
                  <MdInfoOutline />
                </Tooltip>
              </div>
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your password!",
                  },
                  {
                    min: 8,
                    message: "Password must be at least 8 characters long",
                  },
                ]}
              >
                <Input.Password placeholder=" Enter your password" />
              </Form.Item>

              <div className="passoord-tooltip">
                Confirm password
                <Tooltip
                  placement="top"
                  title={tooltipContent}
                  overlayStyle={{ maxWidth: "900px" }}
                >
                  <MdInfoOutline />
                </Tooltip>
              </div>
              <Form.Item
                name="password_confirmation"
                rules={[
                  {
                    required: true,
                    message: "Please enter your Confirm password!",
                  },
                  {
                    min: 8,
                    message: "Password must be at least 8 characters long",
                  },
                ]}
              >
                <Input.Password placeholder=" Enter your confirm password" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  className="submit_login-btn"
                >
                  Sign up
                </Button>
                <div className="first-time_div  forget-to-login">
                  Already have an account? &nbsp;
                  <Link to="/login">
                    <span>Sign in</span>
                  </Link>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Registration;
